var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11C18.2213 11 18.4321 11.094 18.5796 11.2585L22.0364 15.1121C22.3228 15.4314 22.2955 15.9219 21.9754 16.2076C21.6553 16.4934 21.1636 16.4661 20.8772 16.1468L18.7778 13.8064V21.6851C18.7778 22.1136 18.4296 22.461 18 22.461C17.5704 22.461 17.2222 22.1136 17.2222 21.6851V13.8064L15.1228 16.1468C14.8364 16.4662 14.3447 16.4934 14.0246 16.2077C13.7045 15.9219 13.6772 15.4314 13.9636 15.1121L17.4204 11.2585C17.5679 11.094 17.7787 11 18 11ZM11.7778 18.7858C12.2073 18.7858 12.5556 19.1332 12.5556 19.5617V23.8085C12.5556 24.181 12.8453 24.4483 13.1605 24.4483H22.8395C23.1547 24.4483 23.4444 24.181 23.4444 23.8085V19.5617C23.4444 19.1332 23.7927 18.7858 24.2222 18.7858C24.6518 18.7858 25 19.1332 25 19.5617V23.8085C25 24.9997 24.0517 26 22.8395 26H13.1605C11.9484 26 11 24.9998 11 23.8085V19.5617C11 19.1332 11.3482 18.7858 11.7778 18.7858Z",
    fill: "#06070D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7534a87152e8204ae32979f2bd0125cb.svg";
export { ForwardRef as ReactComponent };